export const constants = {
    REQUIRED_FIELD: 'Toto pole je povinné',
    REQUIRED_VALID_DATE_FIELD: 'Zadejte platné datum',
    ISSUE_DATE_GT_TODAY: 'Zadané datum vydání dokladu je pozdější než dnešní datum.',
    EMAIL_FIELD: 'Zadejte e-mail ve správném formátu',
    CELLPHONE_NUMBER: 'Zadejte mobilní telefonní číslo ve správném formátu.',
    TEST_API_URL_CZ: 'https://sp-test-simidecz-ne-app01.azurewebsites.net',
    TEST_API_URL_PL: 'https://sp-test-simidepl-ne-app01.azurewebsites.net',
    PROCESS_ID_QUERY_PARAM: 'ProcessId',
    DATE_FORMAT: 'YYYY-MM-DD',
    HUMAN_DATE_FORMAT: 'D. M. YYYY',
    MAX_DOCUMENT_AGE: 23,
    POLISH_POST_REGEX: '^[0-9]{2}-[0-9]{3}',
    POLISH_BANK_NUMBER: '^(PL)?\\d{26}$',
    MIN_AGE: 18,
    MAX_AGE: 65,
};

export enum ErrorCodes {
    WrongBirthDate = 'err_bankId_birth_date_is_different',
    InvalidIdCard = 'err_idCard_is_expired',
    MissingIssueDtIdCard = 'err_idCard_valid_from_dt_is_missing',
}
